// src/modules/app-views/crm/pages/Boards/components/DraggableCollapseGroup.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { createContext, useContext } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { HolderOutlined } from '@ant-design/icons';

// *******************************************************************************
// CONTEXT
// *******************************************************************************
const DragHandleContext = createContext(null);

export function useDragHandle() {
  return useContext(DragHandleContext);
}

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const DraggableCollapseGroup = props => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { groupUid, children } = props;

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: groupUid,
    data: { type: 'group' },
  });

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    position: 'relative',
    marginBottom: 16,
  };

  const dragHandle = (
    <HolderOutlined
      {...attributes}
      {...listeners}
      style={{ fontSize: 14, cursor: 'grab', opacity: 0.4 }}
    />
  );

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <DragHandleContext.Provider value={dragHandle}>
      <div ref={setNodeRef} style={style}>
        {children}
      </div>
    </DragHandleContext.Provider>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default DraggableCollapseGroup;
